module.exports = __webpack_public_path__ + "static/media/go.db7ac4a7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/templates/blocks/WorkoutBlocks/sound/go.mp3
// module id = 342
// module chunks = 0